import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { CmsProvider } from './contexts/CmsContext';
import ErrorBoundary from './components/layout/ErrorBoundary';
import { useGlobalErrorHandler } from './hooks/useGlobalErrorHandler';
import AppNavigator from './navigation/AppNavigator';
import MentorWidget from './components/MentorWidget';
import { captureUtmParams } from './utils/utm';
import { initTracking } from './services/tracking';

const GOOGLE_CLIENT_ID = (import.meta as any).env.VITE_GOOGLE_CLIENT_ID || '';

if (!GOOGLE_CLIENT_ID) {
  console.error('[Auth] VITE_GOOGLE_CLIENT_ID is not set. Google Sign-In will not work.');
}

function AppInner(): React.JSX.Element {
  useGlobalErrorHandler();
  useEffect(() => {
    captureUtmParams();
    initTracking();
  }, []);
  return (
    <>
      <AppNavigator />
      <MentorWidget />
    </>
  );
}

function App(): React.JSX.Element {
  return (
    <ErrorBoundary>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <BrowserRouter>
          <AuthProvider>
            <CmsProvider>
              <ToastProvider>
                <AppInner />
              </ToastProvider>
            </CmsProvider>
          </AuthProvider>
        </BrowserRouter>
      </GoogleOAuthProvider>
    </ErrorBoundary>
  );
}

export default App;
